module.exports = __webpack_public_path__ + "img/1557614074824564738.17bfd2c3.png";